import * as Yup from "yup"

const validation = {
	defaultFunction: () => ({}),
	defaultSchema: Yup.object({}),
	InsuranceStatus: Yup.object({
		hasInsurance: Yup.string().required("Insurance Status is required")
	}),
	InsurancePolicies: Yup.object({
		hasSubmittedInsurance: Yup.boolean()
			.oneOf([true], "You must submit at least one medical insurance policy")
			.required("You must submit at least one medical insurance policy")
	}),
	DependentDetails: Yup.object({
		dependent: Yup.object({
			firstName: Yup.string().required("First Name is required"),
			lastName: Yup.string().required("Last Name is required"),
			relationship: Yup.string().required("Relationship is required"),
			dateOfBirth: Yup.date().required("Date of Birth is required").typeError("Date of Birth is required"),
			gender: Yup.string().required("Gender is required"),
			addressLine1: Yup.string().required("Street Address is required"),
			city: Yup.string().required("City is required"),
			state: Yup.string().required("State is required"),
			zip: Yup.string().required("Zip Code is required")
		})
	}),
	InsuranceCoverage: Yup.object({
		insuranceCoverage: Yup.string().required("Insurance Coverage is required")
	}),
	InsuranceDetails: Yup.object({
		provider: Yup.object({
			name: Yup.string().required("Insurance Carrier is required")
		})
			.nullable()
			.required("Insurance Carrier is required"),
		policyHolder: Yup.string().required("Policy Holder is required")
	}),
	InsuranceProof: Yup.object({
		insuranceProof: Yup.array()
			.when('healthSherpaPolicyId', {
				is: (val) => Boolean(val),
				then: (schema) => schema.notRequired(),
				otherwise: (schema) => schema
					.of(
						Yup.object({
							id: Yup.string().required("Document ID is required")
						})
					)
					.min(1, "At least one proof of insurance is required")
					.required("Proof of Insurance is required")
			})
	}),
	CoveredIndividuals: Yup.object({
		coveredIndividuals: Yup.array()
			.min(1, "Please select at least one individual")
			.required("Please select at least one individual")
	})
}

export default function getValidation(stepName) {
	const stepValidation = validation?.[stepName]
	let validationFunction = validation.defaultFunction
	if (stepValidation && typeof stepValidation === "function") validationFunction = stepValidation
	let validationSchema = validation.defaultSchema
	if (stepValidation && typeof stepValidation !== "function") validationSchema = stepValidation
	return { validationFunction, validationSchema }
}